var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgDo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M0 85.337h512v341.326H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M0 300.522h211.478v126.141H0z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#0052b4",
  d: "M0 85.337h211.478v126.152H0z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M300.522 85.337H512v126.152H300.522z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#0052b4",
  d: "M300.522 300.522H512v126.141H300.522z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M300.521 256.006c0 24.588-19.932 44.521-44.521 44.521s-44.521-19.932-44.521-44.521S256 211.485 256 211.485s44.521 19.932 44.521 44.521z",
  fill: "#496e2d"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M211.479 256.006c0-24.588 19.932-44.521 44.521-44.521s44.521 19.932 44.521 44.521",
  fill: "#0052b4"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M230.957 233.745v27.825c0 13.831 11.212 25.042 25.043 25.042 13.832 0 25.043-11.212 25.043-25.042v-27.825h-50.086z",
  fill: "#d80027"
})));

export default SvgDo;